import React from "react";

const PaymentGatway = () => {
  return (
    <div className='text-center'>
      <h1 className='mt-5 pt-5'>Payment Gatway is Comming Soon...</h1>
    </div>
  );
};

export default PaymentGatway;
